// extracted by css-extract-rspack-plugin
export default {"svg":"trTBl","svgOnAutoBlink":"ikeIV","gameCard_override":"Ka0d0","gameCardOverride":"Ka0d0","#":"Dj9Qw","container":"G301Q","containerCard":"TELdZ"};